import { Box, Dialog, DialogContent } from "@mui/material";
import { PlaygroundImage } from "../../../models/playground";
import styles from "./ApiReferenceDialog.module.scss";
import ApiReferenceCodeEditor from "./components/ApiReferenceCodeEditor";
import ApiReferenceControlsSection from "./components/ApiReferenceControlsSection";
import ApiReferenceDialogFooter from "./components/ApiReferenceDialogFooter";
import ApiReferenceDialogHeader from "./components/ApiReferenceDialogHeader";
import { useCodeGeneration } from "./hooks/useCodeGeneration";

export interface ApiReferenceDialogProps {
	open: boolean;
	onClose: (e: React.MouseEvent<HTMLButtonElement | SVGElement>) => void;
	image: PlaygroundImage;
}

const ApiReferenceDialog = ({ open, onClose, image }: ApiReferenceDialogProps) => {
	const { selectedExample, setSelectedExample, selectedLanguage, setSelectedLanguage, generateCodeExample } =
		useCodeGeneration(image);

	const code = generateCodeExample();

	return (
		<Dialog open={open} onClose={onClose} fullWidth PaperProps={{ className: styles.dialog }}>
			<DialogContent onClick={(e) => e.stopPropagation()} className={styles.dialogContent}>
				<ApiReferenceDialogHeader onClose={onClose} />

				<Box className={styles.content}>
					<ApiReferenceControlsSection
						selectedLanguage={selectedLanguage}
						setSelectedLanguage={setSelectedLanguage}
						selectedExample={selectedExample}
						setSelectedExample={setSelectedExample}
						code={code}
					/>

					<ApiReferenceCodeEditor code={code} language={selectedLanguage} />
				</Box>

				<ApiReferenceDialogFooter />
			</DialogContent>
		</Dialog>
	);
};

export default ApiReferenceDialog;
